import { render, staticRenderFns } from "./competition-edit.vue?vue&type=template&id=3af073f9&scoped=true"
import script from "./competition-edit.vue?vue&type=script&lang=js"
export * from "./competition-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af073f9",
  null
  
)

export default component.exports